import React from 'react';
import {DateRangePicker} from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import moment from 'moment';
class Calendar extends React.Component {
  state = {
    'focusedInput': null,
    'fullscreen': false,
    'direction': 'left',
    'dateFormat': 'YYYY-MM-DD',
    'small': true,
    'orientation': 'horizontal',
    'numMonths': 1,
  };

  handleFocusChange = (focusedInput) => {
    this.setState({focusedInput});
  };

  handleChangeFullscreen = () => {
    this.setState({'fullscreen': !this.state.fullscreen});
  };

  handleChangeDirection = (e) => {
    this.setState({'direction': e.target.value});
  };

  handleChangeDateFormat = (e) => {
    this.setState({'dateFormat': e.target.value});
  };

  render() {
    const {year, month} = this.props;
    return (
      <div className="calendar__aribnb">
        <DateRangePicker
          startDatePlaceholderText="Fecha  inicio"
          endDatePlaceholderText="Fecha final"
          startDate={this.props.startDate}
          startDateId="startDate"
          endDate={this.props.endDate}
          endDateId="endDate"
          minimumNights={0}
          onDatesChange={this.props.handleDatesChange}
          focusedInput={this.state.focusedInput}
          onFocusChange={this.handleFocusChange}
          displayFormat={this.state.dateFormat}
          hideKeyboardShortcutsPanel={true}
          numberOfMonths={this.state.numMonths || 2}
          small={this.state.small}
          withFullScreenPortal={this.state.fullscreen}
          anchorDirection={this.state.direction}
          orientation={this.state.orientation}
          isOutsideRange={() => false}
          initialVisibleMonth={() => moment(`${month} ${year}`, 'MM YYYY')}
          navPrev={
            <button className={'MyCustomButton'} hidden={true}>
              'Prev'
            </button>
          }
          navNext={
            <button className={'MyCustomButton'} hidden={true}>
              'Prev'
            </button>
          }
        />
      </div>
    );
  }
}

export default Calendar;
